export const getTypes = (state) => state.types.types;

export default getTypes;
